import React from "react";

interface Props {
  isOpen: boolean;
}
const TugStartModal: React.FC<Props> = ({ isOpen }) => {
  if (isOpen) {
    return (
      <div className="assessmet-complete-wrap counter-center-sec">
        <div className="assessmnet-text-wrap">
          <p
            style={{
              fontSize: "64px",
              fontWeight: "700",
              lineHeight: "87.16px",
              textAlign: "center",
              marginBottom: "50px",
              color: "white",
            }}
          >
            Calibration Complete!
          </p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="401"
            height="400"
            viewBox="0 0 401 400"
            fill="none"
          >
            <path
              d="M200.922 0C311.379 0 400.922 89.543 400.922 200C400.922 310.457 311.379 400 200.922 400C90.4649 400 0.921875 310.457 0.921875 200C0.921878 89.543 90.4649 3.10884e-06 200.922 0Z"
              fill="#0F854C"
            />
            <path
              d="M275.922 150L175.922 250L125.922 200"
              stroke="white"
              stroke-width="24"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p
            style={{
              fontSize: "64px",
              fontWeight: "700",
              lineHeight: "87.16px",
              textAlign: "center",
              marginBottom: "50px",
              color: "white",
            }}
          >
            Take a seat to begin assessment.
          </p>
        </div>
      </div>
    );
  }
  return <React.Fragment />;
};
export default TugStartModal;
